import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import debounce from 'lodash/debounce';

import { isMobileDevice } from 'mf-shared/utils/fullSite';

import LayoutNotLoggedIn from './LayoutNotLoggedIn';

type Props = {
  readonly data?: any;
  readonly location?: any;
  readonly children?: React.ReactNode;
};

type State = any;

class Layout extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.updateDimensions = debounce(this.updateDimensions.bind(this), 50, {
      leading: true,
      trailing: false,
    });
    this.state = {
      isMobileDevice: false,
    };
  }

  componentDidMount() {
    this.setState({
      isMobileDevice: isMobileDevice(),
    });
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      isMobileDevice: isMobileDevice(),
    });
  }

  render() {
    const { data, location, children } = this.props;
    // const { externalRedirectURL } = data.moka;

    // we hide the moka layout if redirect to external url,
    // to prevent showing navbar after the login flow finished
    // if (!externalRedirectURL) {
    //   return <div />;
    // }

    return (
      <div>
        <div className="full-height">
          <LayoutNotLoggedIn data={data} location={location}>
            {children}
          </LayoutNotLoggedIn>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    data: {
      notification: state.notification,
      openPlatform: {
        login: {
          isMokaOpenApiRedirect: state.openPlatform.login.isMokaOpenApiRedirect,
        },
      },
    },
  };
}

export default connect(select)(withRouter(Layout));
